<template>
  <div class="mt-5">
    <!--   <div class="placeholder_container mb-5">
      <div class="placeholder_slider"></div>
    </div>
    <div class="title-placeholder"></div> -->
    <!--  <draggable v-model="pax_list" @start="drag = true" group="people" @end="drag = false" item-key="id">
      <template #footer>
        <button>Add</button>
      </template>
    </draggable>
    <div v-for="color in colors" :key="color">
      <div style="height: 60px" :style="[`background-color: var(--${color})`, `color:white`]">{{ color }}</div>
    </div> -->
  </div>
</template>

<script>
import DropDown from "@/components/ui/dropdown";
import Draggable from "vuedraggable";
export default {
  name: "Home",
  title: `DashBoard`,
  components: { DropDown, Draggable },
  data() {
    return {
      drag: false,
      pax_list: [
        {
          name: "Joao",
          id: 1
        },
        {
          name: "Jean",
          id: 2
        },
        {
          name: "John",
          id: 0
        }
      ],
      open_modal: false,
      colors: [
        "body-background-color",
        "body-text-color",
        "dp-c-table-header-background",
        "dp-c-table-header-body-hover",
        "dp-c-table-header-border",
        "dp-c-table-odd-row-background",
        "dp-c-table-even-row-background",
        "dp-c-border-color",
        "dp-c-card-background",
        "dp-c-input-border",
        "dp-c-input-focus-shadow",
        "dp-c-input-placeholder-color",
        "dp-c-card-shadow",
        "dp-c-popover-overlay-background",
        "dp-c-modal-overlay-background",
        "dp-c-input-disabled-color",
        "dp-c-profile-image-hover",
        "dp-c-calender-disabled-background",
        "dp-c-calender-box-shadow",
        "dp-c-calender-time_hover",
        "dp-c-breadcrumb-active-color",
        "dp-c-notification-hover",
        "dp-c-notification-border",
        "dp-c-container-loading",
        "dp-chat-background-color",
        "dp-chat-heading-background",
        "dp-chat-conversation-background",
        "dp-chat-input-section",
        "dp-activities-after-background",
        "dp-activities-content-background",
        "dp-activities-child-background",
        "dp-passengers-details-listing-background"
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--dp-content-background);
  font-size: var(--fnt-18);
  box-shadow: var(--shadow-white);
}

.loader {
  width: 3em;
  height: 3em;
  cursor: not-allowed;
  border-radius: 50%;
  border: 2px solid #444;
  box-shadow: -10px -10px 10px #6359f8, 0 -10px 10px 0 #9c32e2, 10px -10px 10px #f36896, 10px 0 10px #ff0b0b, 10px 10px 10px 0 #ff5500, 0 10px 10px 0 #ff9500, -10px 10px 10px 0#ffb700;
  animation: load 0.7s linear infinite;
  .loader_in {
    border: 2px solid #444;
    width: 1.5em;
    height: 1.5em;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

@keyframes load {
  to {
    transform: rotate(360deg);
  }
}

// SCSS for title loader animation (Dark Theme)
$title-placeholder-height: 30px;
$title-placeholder-width: 60%;
$title-loader-color-dark: #333333;
$title-loader-background-dark: linear-gradient(90deg, #3a3a3a 25%, #2a2a2a 50%, #3a3a3a 75%);
$title-loader-duration: 1.5s;

.placeholder_container {
  height: 30px;
  width: 100%;
  background-color: #ff0b0b;
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  margin: 20px auto;
  .placeholder_slider {
    height: 100%;
    width: 25%;
    left: -100%;
    position: absolute;
    top: 0;
    animation: loading $title-loader-duration infinite;
    background: linear-gradient(90deg, #3a3a3a 25%, #2a2a2a 50%, #3a3a3a 75%);
  }
}

.title-placeholder {
  width: $title-placeholder-width;
  height: $title-placeholder-height;
  background-color: $title-loader-color-dark;
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  margin: 20px auto;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    height: 100%;
    width: 100%;
    background: $title-loader-background-dark;
    animation: loading $title-loader-duration infinite;
  }
}

@keyframes loading {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
</style>


 <!-- <div class="loader">
      <div class="loader_in"></div>
    </div> -->
  <!--     <div class="card dark">
      <div class="card-header">alkjsdlkajslkasdj</div>
      <div class="card-body">alkjsdlkajslkasdj</div>
      <div class="card-footer">alkjsdlkajslkasdj</div>
    </div> -->
  <!--  <div class="row">
      <div class="col-3"><div class="box">Coming Soon</div></div>
      <div class="col-3"><div class="box">Coming Soon</div></div>
      <div class="col-3"><div class="box">Coming Soon</div></div>
      <div class="col-3"><div class="box">Coming Soon</div></div>
    </div>

    <div class="row mt-4">
      <div class="col-6"><div class="box">Coming Soon</div></div>
      <div class="col-6"><div class="box">Coming Soon</div></div>
    </div>

    <div class="row mt-4">
      <div class="col-4"><div class="box">Coming Soon</div></div>
      <div class="col-4"><div class="box">Coming Soon</div></div>
      <div class="col-4"><div class="box">Coming Soon</div></div>
    </div> -->